(() => {
    window.ezfyReadingTime = window.ezfyReadingTime || {};

    function ezfyCalculateReadingTime(text, options = {}) {
        const stripHTMLTags = (html) => html.replace(/<[^>]*>/g, "");
        const stripMediaTags = (text) => text.replace(/<img[^>]*>|<\/?video[^>]*>/gi, '');
        const isAnsiWordBound = (char) => " \n\r\t".includes(char);
        const codeIsInRanges = (code, ranges) => ranges.some(([start, end]) => start <= code && code <= end);
        const isCJK = (char) => typeof char === "string" && codeIsInRanges(char.charCodeAt(0), [
            [12352, 12447],
            [19968, 40959],
            [44032, 55203],
            [131072, 191456]
        ]);
        const isPunctuation = (char) => typeof char === "string" && codeIsInRanges(char.charCodeAt(0), [
            [33, 47],
            [58, 64],
            [91, 96],
            [123, 126],
            [12288, 12351],
            [65280, 65519]
        ]);

        let cleanedText = stripHTMLTags(stripMediaTags(text));
        let wordCount = 0;
        let start = 0;
        let end = cleanedText.length - 1;
        const wordsPerMinute = options.wordsPerMinute || 200;
        const wordBound = options.wordBound || isAnsiWordBound;

        while (wordBound(cleanedText[start])) start++;
        while (wordBound(cleanedText[end])) end--;

        const textWithNewline = `${cleanedText}\n`;
        for (let i = start; i <= end; i++) {
            if (
                isCJK(textWithNewline[i]) ||
                (!wordBound(textWithNewline[i]) &&
                    (wordBound(textWithNewline[i + 1]) || isCJK(textWithNewline[i + 1])))
            ) {
                wordCount++;
            }
            if (isCJK(textWithNewline[i])) {
                while (i <= end && (isPunctuation(textWithNewline[i + 1]) || wordBound(textWithNewline[i + 1]))) {
                    i++;
                }
            }
        }

        const minutes = wordCount / wordsPerMinute;
        const displayText = `Tiempo estimado de lectura: ${Math.ceil(minutes)} MIN`;

        return {
            text: displayText,
            minutes: minutes,
            words: wordCount,
            time: `Lectura: ${Math.ceil(minutes)} min `
        };
    }

    function initReadingTime() {
        const containers = document.querySelectorAll('.ezfyReadingTime');
        containers.forEach((container) => {
            const textElement = container.querySelector('.ezfyReadingTime-text');
            const textSource = container.getAttribute('data-text') || '';
            const showWords = container.getAttribute('data-show-words') === 'true';
            const showDataLabel = container.getAttribute('data-show-label');

            if (textElement && textSource) {
                const result = ezfyCalculateReadingTime(textSource);
                const wordsText = showWords ? ` (${result.words} palabras)` : '';
                
                if(showDataLabel) {
                    textElement.textContent = `${showDataLabel} ${result.time}`;
                } else {
                    textElement.textContent = `${result.time}`;
                }
                // textElement.textContent = `${showDataLabel} ${result.time}`;
                container.classList.add('ezfyReadingTime--visible');
            }
        });
    }

    document.addEventListener("DOMContentLoaded", initReadingTime);
})();